import { render } from "./TestimonioIntelNew.vue?vue&type=template&id=0c027058&scoped=true"
import script from "./TestimonioIntelNew.vue?vue&type=script&lang=js"
export * from "./TestimonioIntelNew.vue?vue&type=script&lang=js"

import "./TestimonioIntelNew.vue?vue&type=style&index=0&id=0c027058&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c027058"]])

export default __exports__